<h5>AVISO — TAREAS INACABADAS</h5>
<p>Este plan tiene {{ pendingTasks }} tareas sin cerrar.</p>
<p>
  Si cierras el plan ahora, esas tareas quedarán archivadas como inacabadas y no podrán finalizarse ni ejecutarse
  después. Tampoco se trasladarán al siguiente plan.
</p>
<p>
  Puedes prorrogar el plan para mantener su trabajo activo, evaluar y cerrar asumiendo las tareas como inacabadas,
  o cancelar y continuar con el plan actual.
</p>

<div class="w-full flex flex-row items-center gap-2 pt-3 flex-wrap">
  <button (click)="choose('extend')"
          class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Prorrogar" class="h-4 filter-primary-600" src="/assets/icons/feather/clock.svg">
    <span class="cd-text-md truncate">Prorrogar</span>
  </button>

  <button (click)="choose('close')"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Evaluar y cerrar" class="h-4 filter-neutral-100" src="/assets/icons/feather/check-circle.svg">
    <span class="cd-text-md truncate">Evaluar y cerrar</span>
  </button>

  <button (click)="choose('cancel')"
          class="btn btn-neutral-outline flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Cancelar" class="h-4 filter-neutral-800-600" src="/assets/icons/feather/x.svg">
    <span class="cd-text-md truncate">Cancelar</span>
  </button>
</div>

